export default __webpack_public_path__ + "static/DIGIC_ESZR_2023-95cb94a6633813deb0fb4db4647bfc92.pdf";